<style lang="less">
.order-item {
  padding: 10px 20px;
  .order-item-image {
    width: 100px;
    height: 100px;
  }
  .order-item-title {
  }
  .order-item-price {
  }
  .order-item-number {
  }
}
</style>

<template>
  <div class="order-item flex row flex-cc">
    <img class="order-item-image" :src="product.image"/>
    <div class="flex col pl-20">
      <span class="order-item-title">{{ product.productName }}</span>
      <div class="flex row flex-sb">
        <span class="order-item-price">{{ product.salePrice }}</span>
        <span class="order-item-number">X{{ product.number }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  }
}
</script>